import React from "react";
import PropTypes from "prop-types";

export const Youtube = ({ color = "#F61C0D" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.0077 7.96806C20.9108 7.6077 20.7133 7.27752 20.4353 7.01088C20.1574 6.74423 19.8087 6.55056 19.4245 6.44944C18.0208 6.13052 12.4061 6.13052 12.4061 6.13052C12.4061 6.13052 6.79141 6.13052 5.38773 6.47981C5.00356 6.58094 4.65487 6.7746 4.37688 7.04125C4.09889 7.30789 3.90146 7.63807 3.80452 7.99844C3.54762 9.32386 3.42196 10.6684 3.42912 12.0152C3.41996 13.3721 3.54563 14.7269 3.80452 16.0623C3.91139 16.4115 4.11325 16.7291 4.39059 16.9845C4.66793 17.2399 5.01137 17.4244 5.38773 17.5202C6.79141 17.8695 12.4061 17.8695 12.4061 17.8695C12.4061 17.8695 18.0208 17.8695 19.4245 17.5202C19.8087 17.4191 20.1574 17.2254 20.4353 16.9588C20.7133 16.6921 20.9108 16.362 21.0077 16.0016C21.2626 14.6862 21.3883 13.3518 21.3831 12.0152C21.3923 10.6583 21.2666 9.30347 21.0077 7.96806Z" fill="#242424"/>
      <path d="M10.5704 14.4965L15.263 12.0136L10.5704 9.53064V14.4965Z" fill="white" stroke="white" stroke-width="1.47157" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  );
};
Youtube.propTypes = {
  color: PropTypes.string,
};
